import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Tiny event-bus so non-component code (e.g. a nav item function route)
 * can tell the AryaChatComponent to open in full-screen mode.
 *
 * Usage:
 *   - Emit:     aryaChatService.openFull$.next()
 *   - Subscribe: aryaChatService.openFull$.subscribe(() => this.openFull())
 */
@Injectable({ providedIn: 'root' })
export class AryaChatService {
  readonly openFull$ = new Subject<void>();
}
